<template>
  <step :context="{}">
    <div class="congrats">
      <img src="/images/congrats.svg" />
      <div class="header">Congratulations!</div>
      <div class="text">
        You have sucessfully completed the onboarding process for Loyalty XT.
        We will enable Loyalty XT the night before your Go Live date and you will receive an email notifiction.
        If you want to change your Go Live date, please make sure to inform Revel Support at support@revelsystems.com
      </div>
    </div>
  </step>
</template>

<script>
import Step from "./Step";
export default {
  components: {
    Step
  }
};
</script>

<style lang="scss" scoped>
.congrats {
  height: 100%;

  img {
    display: none;
  }
  background-image: url("/images/congrats.svg");
  background-repeat: no-repeat;
  background-position: 100% 100%;
  background-size: 68%;

  .header {
    font-size: 52px;
    font-weight: bold;
    color: #333d4d;
    margin: 58px 0 -10px;
  }

  .text {
    font-size: 18px;
    font-weight: 300;
    line-height: 1.56;
    max-width: 690px;
    color: #333d4d;
    white-space: pre-line;
    & .bold,a {
      font-weight: 500;
    }
    ul {
      list-style-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='20' height='10' viewBox='-1 -1 2 2'><circle r='0.4' /></svg>");
    }
    tab-size: 62px;
    text-shadow: white 1px 1px 1px;
  }

  #app.mobile & {
    height: fit-content;
    padding: 0 30px 40px;
    background-image: none;
    img {
      display: initial;
      width: 124vw;
      position: relative;
      left: calc(-15px - 12vw);
    }
    .header {
      font-size: 36px;
      margin: 0;
    }
  }
}
</style>
